//imports
import { all, call, fork, takeEvery, put } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    DEVICES_BY_STATUS_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    devicesByStatusResult,
} from 'Redux/actions';

function* searchDevicesByStatus({ payload }) {
    const { age, dealerId, unitStatus, accountId, manufacturerId, deviceModelId, gadget, offset, clear, tagIds } = payload
    try {
        let QUERY = `
            query searchDevicesByStatus ($age: Int!, $unitStatus: [Int]!, $dealerId: Int, $accountId: Int, $manufacturerId: Int, $deviceModelId: Int, $limit: Int, $offset: Int, $tagIds: [Int]) {
                result: searchDevicesByStatus (age: $age, unitStatus: $unitStatus, dealerId: $dealerId, accountId: $accountId, manufacturerId: $manufacturerId, deviceModelId: $deviceModelId, limit: $limit, offset: $offset, tagIds: $tagIds) {
                    items {
                        id
                        accountId
                        accountName
                        esn
                        deviceId
                        eventName
                        lastMessageTime
                        age
                        status
                        manufacturerName
                        timezone
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                age,
                dealerId,
                unitStatus,
                accountId,
                manufacturerId,
                deviceModelId,
                limit: 100,
                offset: offset || 0,
                tagIds: tagIds || []
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result.items) {
            yield put(devicesByStatusResult(data?.result, gadget, clear))
        } else {
            yield put(devicesByStatusResult(null, gadget, true))
        }

    } catch (exc) {
        yield put(devicesByStatusResult(null, gadget, true))
        ExceptionManager(exc, 'Modules/dashboard/views/.components/chart/.components/devicesByStatus/redux/saga', 'searchDevicesByStatus', true);
    }
}

function* watchDashboardPanelRequests() {
    yield takeEvery(DEVICES_BY_STATUS_REQUEST, searchDevicesByStatus);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchDashboardPanelRequests)
    ]);
}